import React from "react";
import { Modal } from "antd";
import { IconExclamation } from "../Layout/Icons";
const { confirm } = Modal;

export default function ButtonConfirm({
  className = "btn-white",
  style,
  onClick,
  children,
}) {
  const onSubmit = () => {
    confirm({
      title: "Are you sure?",
      icon: <IconExclamation className="text-primary" />,
      content: "You will not be able to undo this action",
      onOk() {
        onClick();
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  return (
    <button onClick={onSubmit} className={className} style={style}>
      {children}
    </button>
  );
}
